import {
  FormControl,
  FormHelperText,
  MenuItem,
  Select,
  SelectProps
} from "@mui/material";

interface HolzfinderSelectOptions {
  label: string;
  value: string | number;
}

export type HolzfinderSelectProps = Omit<SelectProps, 'variant'> &
{
  id: string;
  label: string;
  options: HolzfinderSelectOptions[];
  currentValue: string | number;
  disabled?: boolean;
  helperText?: string;
}

export default function HolzfinderSelect(props: HolzfinderSelectProps) {
  const { id, label, options, currentValue, onChange, disabled, helperText, ...rest } = props;
  return (
    <FormControl sx={{ width: "100%" }} error={Boolean(props.error)}>
      <label
        id={`${id}_label`}
        className={`${id}_class`}
        htmlFor={id}
        style={{ whiteSpace: "pre", marginBottom: "8px" }}
      >
        {label}
      </label>
      <Select
        // defaultValue={false}
        // labelId={`${id}_label`}
        id={id}
        {...rest}
        disabled={disabled}
        value={currentValue}
        onChange={onChange}
        // label="label"
        sx={{
          borderRadius: 30,
          height: 51,
          margin: "5px"
        }}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
        ))}
      </Select>
      <FormHelperText>{helperText}</FormHelperText>
    </FormControl>
  );
}
